const NullComponent = () => null;

export const FootNote = NullComponent;
export const AdditionalInfo = NullComponent;
export const Questionnaire = NullComponent;
export const BuildingMap = NullComponent;
export const PrivacyPolicy = NullComponent;
